/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconServer = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 32 32"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 32px;
      `}
      {...props}
    >
      <defs>
        <path id="a" d="M0 0h32v32H0z" />
      </defs>
      <g fill={fill} fillRule="evenodd">
        <g>
          <mask id="b" fill="white">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="currentColor"
            d="M29 30.5H3c-.827 0-1.5-.673-1.5-1.5v-7.167h29V29c0 .827-.673 1.5-1.5 1.5zM1.5 20.333h29v-8.667h-29v8.667zM1.5 3c0-.827.673-1.5 1.5-1.5h26c.827 0 1.5.673 1.5 1.5v7.166h-29V3zM29 0H3a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z"
            mask="url(#b)"
          />
        </g>
        <path
          fill="currentColor"
          d="M5.5 4.333a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M5.5 14.5a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M5.5 24.666a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M10.5 4.333a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M10.5 14.5a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M10.5 24.666a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M15.5 4.333a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M15.5 14.5a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3M15.5 24.666a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3"
        />
      </g>
    </svg>
  ),
);
